function generateDefaultInitialAccountState() {
  return {
    userInfo: {
      cartCount: 0,
    },
    areAdultImagesVisible: false,
  };
}

function accountReducer(state = generateDefaultInitialAccountState(),
                        action) {
  let newState;

  switch (action.type) {
    case 'GET_USER_INFO_FULFILLED': {
      newState = {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...action.payload.response.data,
        },
      };

      break;
    }

    case 'GET_CART_ITEM_COUNT_FULFILLED': {
      newState = {
        ...state,
        userInfo: {
          ...state.userInfo,
          cartCount: action.payload.response.data.cartItemCount,
        },
      };

      break;
    }

    case 'ADD_TO_CART_FULFILLED': {
      newState = {
        ...state,
        userInfo: {
          ...state.userInfo,
          cartCount: action.payload.response.data.data.count,
        },
      };

      break;
    }

    case 'SET_USER_INFO_FULFILLED': {
      newState = {
        ...state,
        userInfo: {
          ...state.userInfo,
          ...action.triggerPayload.params,
        },
      };

      break;
    }

    default:
      newState = state;
  }

  return newState;
}

export default accountReducer;
export {generateDefaultInitialAccountState};
